const About = () => (
  <section id="about" style={{ maxWidth: "1280px", margin: "0 auto", padding: "104px 24px", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(480px, 100%), 1fr))", gap: "56px", alignItems: "center" }}>
    <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
      <span style={{ fontWeight: "700", color: "#1E8F80", fontSize: "16px" }}>
        من نحن ؟
      </span>
      <h2 style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "clamp(34px, 4vw, 52px)", lineHeight: "1.2", width: "min(672px, calc(100vw - 48px))" }}>
        <ul dir="rtl">
          <li>
            <strong>
              جيلٌ يتعلّم بطريقة مختلفة… يستحقّ تطبيقًا مختلفًا.
            </strong>
          </li>
        </ul>
      </h2>
      <div style={{ margin: "0", fontSize: "18px", lineHeight: "1.9", color: "#3A4270" }}>
        <div dir="rtl">
          <p dir="rtl">
            {"«خُطوة» تطبيق تعليميّ  يُعيد تصوّر التعلّم في المرحلة الابتدائيّة للأطفال من 5 إلى 12 سنة."}
          </p>
          {" "}
          <div dir="rtl" style={{ margin: "8px 0", display: "flex", flexDirection: "column", gap: "12px", padding: "22px 24px", borderRadius: "24px", background: "#F1EDFF", border: "2px solid #D9CFFF", boxShadow: "0 6px 0 #D9CFFF" }}>
            <span style={{ alignSelf: "flex-start", display: "inline-flex", alignItems: "center", gap: "8px", padding: "5px 14px", borderRadius: "999px", background: "#5B3FB0", color: "#FFFFFF", fontWeight: "800", fontSize: "14px" }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <rect x="6" y="2.5" width="12" height="19" rx="3" />
                <path d="M10.5 18.5h3" />
              </svg>
              {"جيل ألفا · "}
              <span dir="ltr">
                Gen Alpha
              </span>
            </span>
            <p dir="rtl" style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', 'IBM Plex Sans Arabic', sans-serif", fontWeight: "700", fontSize: "clamp(20px, 2vw, 24px)", lineHeight: "1.75", color: "#141C63" }}>
              {"صُمّم خصّيصًا "}
              <span style={{ color: "#5B3FB0", fontWeight: "800" }}>
                لجيل ألفا
              </span>
              {"، جيلٍ وُلد مع الشاشات، يتعلّم "}
              <span style={{ padding: "0 8px", borderRadius: "10px", background: "#CFF5EE", color: "#0B5F55" }}>
                بالصورة
              </span>
              {" "}
              <span style={{ padding: "0 8px", borderRadius: "10px", background: "#FFE3C7", color: "#8A3E05" }}>
                والحركة
              </span>
              {" "}
              <span style={{ padding: "0 8px", borderRadius: "10px", background: "#FCD9EC", color: "#8E1F5F" }}>
                والتفاعل
              </span>
              {"، ويحتاج إلى تجارب تُشبه عالمه وتُخاطب "}
              <span style={{ color: "#1E8F80", fontWeight: "800" }}>
                فضوله
              </span>
              .
            </p>
          </div>
          {" "}
          <p dir="rtl">
            وبفضل الجمع بين اللعب وتقنية الواقع المعزّز، يُقدّم «خُطوة» تجربة غامرة وتفاعليّة فريدة: سيناريوهات مليئة بالألعاب ثنائيّة وثلاثيّة الأبعاد، صُمّمت لتنمية المهارات المعرفيّة بطريقة مسلّية ومبدعة، وتُراعي خصوصيّة كلّ طفل، ليتعلّم بمتعة ويتقدّم بثقة.
          </p>
        </div>
        {" "}
        <p dir="rtl">
          <br />
        </p>
      </div>
      <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
        <span style={{ padding: "8px 16px", borderRadius: "999px", background: "#E2F7F3", color: "#145E55", fontWeight: "700", fontSize: "14px" }}>
          واقع معزّز
        </span>
        <span style={{ padding: "8px 16px", borderRadius: "999px", background: "#E6E9FF", color: "#1C2580", fontWeight: "700", fontSize: "14px" }}>
          ذكاء اصطناعي
        </span>
        <span style={{ padding: "8px 16px", borderRadius: "999px", background: "#FFF3CC", color: "#6E4A00", fontWeight: "700", fontSize: "14px" }}>
          ألعاب 2D / 3D
        </span>
        <span style={{ padding: "8px 16px", borderRadius: "999px", background: "#FDE6F3", color: "#8E1F5F", fontWeight: "700", fontSize: "14px" }}>
          تعلّم شخصي
        </span>
      </div>
    </div>
    <div style={{ position: "relative" }}>
      <img width="1376" height="768" loading="lazy" decoding="async" src="/assets/img/kids-ar-vr-school.webp" alt="أطفال يتعلّمون بالواقع الافتراضي والمعزّز في ساحة المدرسة" style={{ width: "100%", borderRadius: "32px", display: "block", boxShadow: "0 30px 60px rgba(20,28,99,0.2)" }} />
    </div>
  </section>
);

export default About;
